import { createStorefrontClient } from "@shopify/hydrogen-react";

let _getStorefrontApiUrl;
let _headers;

function initShopify() {
  let client = createStorefrontClient({
    storeDomain: "tbzty5-e8.myshopify.com",
    publicStorefrontToken: "7aa9302a364780ffe10b0dc20e099560",
  });
  _getStorefrontApiUrl = client.getStorefrontApiUrl();
  _headers = client.getPublicTokenHeaders();

  return {
    headers: _headers,
    getStorefrontApiUrl: _getStorefrontApiUrl,
  };
}

function headers() {
  return _headers || initShopify().headers;
}

function getStorefrontApiUrl() {
  return _getStorefrontApiUrl || initShopify().getStorefrontApiUrl;
}

// Fetch all products
export async function getProducts() {
  const allProducts = [];
  let hasNextPage = true;
  let endCursor = null;

  while (hasNextPage) {
    const query = `
      query Products($cursor: String) {
        products(first: 100, after: $cursor) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              title
              handle
              productType
              vendor
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
           
              variants(first: 1) {
                edges {
                  node {
                    id
                    availableForSale
                    sku
                    price {
                      amount
                      currencyCode
                    }
                    image {
                      url
                      altText
                      width
                      height
                    }
                  }
                }
              }
              featuredImage {
                url
                altText
                width
                height
              }
                     metafields(identifiers:[
     {namespace:"custom", key: "specification"},
     {namespace:"categories", key:"sub_category"},
     {namespace:"categories", key:"main_category"},
     {namespace:"farminsta", key:"product_about"},
     {namespace:"farminsta", key:"field_sales_commission"},
    ]) {
     id
     namespace
     key
     value
     
     reference {
      __typename
      ... on Metaobject {
       id
       handle
       
       updatedAt
       fields {
        key
        type
        value
       }
      }
     }
    }

              images(first: 1) {
                edges {
                  node {
                    url
                    altText
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
    `;

    const response = await fetch(getStorefrontApiUrl(), {
      method: "POST",
      headers: headers(),
      body: JSON.stringify({
        query,
        variables: {
          cursor: endCursor,
        },
      }),
    });

    const json = await response.json();

    const edges = json.data.products.edges;
    allProducts.push(
      ...edges.map((edge) => ({
        ...edge.node,
        image:
          edge.node.featuredImage ||
          edge.node.images?.edges?.[0]?.node ||
          edge.node.variants?.edges?.[0]?.node?.image ||
          null,
        variantId: edge.node.variants?.edges?.[0]?.node?.id,
        metafields: edge.node.metafields,
      }))
    );

    hasNextPage = json.data.products.pageInfo.hasNextPage;
    endCursor = json.data.products.pageInfo.endCursor;
  }

  return allProducts;
}

// Fetch a single product by handle
export async function getProduct(handle: string, locale: string = "en") {
  console.log("Fetching product with handle:", handle);
  const query = `
    query Product($handle: String!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) {
      product(handle: $handle) {
        id
        title
        description
        descriptionHtml
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        images(first: 10) {
          edges {
            node {
              url
              altText
              width
              height
            }
          }
        }
        variants(first: 20) {
          edges {
            node {
              id
              title
              availableForSale
              price {
                amount
                currencyCode
              }
              sku
              image {
                url
                altText
                width
                height
              }
            }
          }
        }
        seo {
          title
          description
        }
        vendor
        productType
        tags
           
        metafields(identifiers:[
     {namespace:"custom", key: "specification"},
     {namespace:"categories", key:"sub_category"},
     {namespace:"categories", key:"main_category"},
     {namespace:"farminsta", key:"product_about"},
      {namespace:"farminsta", key:"field_sales_commission"},
    ]) {
     id
     namespace
     key
     value
     
     reference {
      __typename
      ... on Metaobject {
       id
       handle
       
       updatedAt
       fields {
        key
        type
        value
       }
      }
     }
    }
   customFeatures: metafield(namespace: "custom", key: "features") {
          key
          value
          namespace
        }
      }
      localization {
        language {
          isoCode
          endonymName
          name
        }
        country {
          isoCode
          name
          currency {
            isoCode
            name
            symbol
          }
        }
        availableLanguages {
          isoCode
          endonymName
          name
        }
      }
    }
  `;

  try {
    const response = await fetch(getStorefrontApiUrl(), {
      method: "POST",
      headers: headers(),
      body: JSON.stringify({
        query,
        variables: {
          handle,
          country: "IN",
          language: locale.toUpperCase(),
        },
      }),
    });

    const json = await response.json();
    console.log("Product fetch response:", json);

    if (json.errors) {
      console.error("Shopify API Errors:", json.errors);
      throw new Error("Failed to fetch product");
    }

    return {
      data: {
        product: json.data.product,
        localization: json.data.localization,
      },
    };
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
}

// Create or update cart
export async function manageCart(
  cartId: string | null,
  lines: { merchandiseId: string; quantity: number }[],
  buyerAccessToken?: string
) {
  console.log("Managing cart:", { cartId, lines, buyerAccessToken });

  const cartFragment = `
    fragment CartFields on Cart {
      id
      totalQuantity
      checkoutUrl
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
      }
      lines(first: 100) {
        edges {
          node {
            id
            quantity
            cost {
              totalAmount {
                amount
                currencyCode
              }
            }
            merchandise {
              ... on ProductVariant {
                id
                title
                price {
                  amount
                  currencyCode
                }
                image {
                  url
                  altText
                  width
                  height
                }
                product {
                  title
                  handle
                  vendor
                  featuredImage {
                    url
                    altText
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  // Different mutations for add, update, and remove
  const addMutation = `
    mutation CartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
      cartLinesAdd(cartId: $cartId, lines: $lines) {
        cart {
          ...CartFields
        }
        userErrors {
          field
          message
        }
      }
    }
    ${cartFragment}
  `;

  const updateMutation = `
    mutation CartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart {
          ...CartFields
        }
        userErrors {
          field
          message
        }
      }
    }
    ${cartFragment}
  `;

  const createMutation = `
    mutation CartCreate($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          ...CartFields
        }
        userErrors {
          field
          message
        }
      }
    }
    ${cartFragment}
  `;

  try {
    // Determine if this is a new cart, an update, or a removal
    const isNewCart = !cartId;
    const isUpdate = cartId && lines.every((line) => line.merchandiseId);
    const isRemove = cartId && lines.every((line) => line.quantity === 0);

    const query = isNewCart
      ? createMutation
      : isUpdate
      ? addMutation
      : updateMutation;

    let variables;

    if (isNewCart) {
      variables = {
        input: {
          lines: lines.map((line) => ({
            merchandiseId: line.merchandiseId,
            quantity: line.quantity,
          })),
        },
      };
    } else if (isUpdate) {
      variables = {
        cartId,
        lines: lines.map((line) => ({
          merchandiseId: line.merchandiseId,
          quantity: line.quantity,
        })),
      };
    } else {
      variables = {
        cartId,
        lines: lines.map((line) => ({
          id: line.id,
          quantity: line.quantity,
        })),
      };
    }

    console.log("Sending cart mutation:", {
      query,
      variables,
    });

    const authHeaders = {
      ...headers(),
      ...(buyerAccessToken
        ? { Authorization: "Bearer " + buyerAccessToken }
        : {}),
    };

    const response = await fetch(getStorefrontApiUrl(), {
      method: "POST",
      headers: authHeaders,
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    const json = await response.json();
    console.log("Cart operation response:", json);

    if (json.errors) {
      console.error("Shopify API Errors:", json.errors);
      throw new Error(json.errors[0]?.message || "Failed to manage cart");
    }

    const operation = isNewCart
      ? "cartCreate"
      : isUpdate
      ? "cartLinesAdd"
      : "cartLinesUpdate";
    const result = json.data?.[operation];

    if (!result?.cart) {
      throw new Error("No cart data returned from Shopify");
    }

    if (result.userErrors?.length > 0) {
      console.error("Cart operation errors:", result.userErrors);
      throw new Error(result.userErrors[0].message);
    }

    return result;
  } catch (error) {
    console.error("Error managing cart:", error);
    throw error;
  }
}

// Map your product interface to Shopify's structure
export function mapToShopifyProduct(product: any) {
  return {
    title: product.title,
    description: product.description,
    basePrice: parseFloat(product.priceRange.minVariantPrice.amount),
    retailPrice: parseFloat(product.variants.edges[0]?.node.price.amount),
    availableStock: product.variants.edges[0]?.node.availableForSale ? 1 : 0,
    seller: product.vendor,
    sku: product.variants.edges[0]?.node.sku,
    brandName: product.vendor,
    manufacturerName: product.vendor,
    // Add other mappings as needed
  };
}

export async function updateCartBuyerIdentity(cartId, customerAccessToken) {
  const mutation = `
    mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
      cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
        cart {
          id
          checkoutUrl
        }
        userErrors {
          field
          message
        }
      }
    }
  `;
  const variables = {
    cartId,
    buyerIdentity: {
      customerAccessToken,
    },
  };

  const response = await fetch(getStorefrontApiUrl(), {
    method: "POST",
    headers: headers(),
    body: JSON.stringify({
      query: mutation,
      variables,
    }),
  });

  const json = await response.json();
  if (json.errors) {
    console.error("Shopify cartBuyerIdentityUpdate errors:", json.errors);
    throw new Error(
      json.errors[0]?.message || "Failed to update buyer identity"
    );
  }

  const result = json.data?.cartBuyerIdentityUpdate;
  if (result?.userErrors?.length) {
    console.error("cartBuyerIdentityUpdate userErrors:", result.userErrors);
    throw new Error(result.userErrors[0].message);
  }

  return result.cart;
}
